import { TableColumn } from '../components/common/LineItemTable';
import { InvoiceStatus } from '../@types';

export const REPEAT_EVERY_WEEK = 'Weekly';
export const REPEAT_EVERY_2_WEEKS = '2 weeks';
export const REPEAT_EVERY_MONTH = 'Month';
export const REPEAT_EVERY_2_MONTHS = '2 months';
export const REPEAT_EVERY_3_MONTHS = '3 months';
export const REPEAT_EVERY_6_MONTHS = '6 months';
export const REPEAT_EVERY_YEAR = 'Year';
export const REPEAT_EVERY_2_YEARS = '2 year';
export const REPEAT_EVERY_3_YEARS = '3 year';

export const INVOICE_TABLE_HEADER: TableColumn[] = [
  { label: 'Items/Description', key: 'name', toLowerCase: () => 'name' },
  { label: 'Quantity', key: 'quantity', toLowerCase: () => 'quantity' },
  { label: 'Rate', key: 'rate', toLowerCase: () => 'rate' },
  { label: 'Amount', key: 'amount', toLowerCase: () => 'amount' },
  { label: '', key: 'amount', toLowerCase: () => 'remove' },
];

export const REOCCURRING_FREQUENCY = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
];

export const Statuses: { CANCELLED: string; DRAFT: string; PAID: string; PENDING: string; DUE: string, REFUNDED: string } = {
  PAID: 'Paid',
  PENDING: 'Pending',
  DRAFT: 'Draft',
  DUE: 'Due',
  CANCELLED: 'Cancelled',
  REFUNDED: 'Refunded',
};

export const STATUS_TEXT = {
  paid: 'Paid',
  cancelled: 'Cancelled',
  pending: 'Pending',
  due: 'Due',
  draft: 'Draft',
  refunded: 'Refunded',
};